/* globals Forms, Timeago, Profile, bootstrap, history */

import 'lib/profile'
import 'lib/timeago'

window['employees#edit'] = function () {
  const tabsEl = document.querySelector('#employee-tabs')
  if (!tabsEl) return

  const hash = window.location.hash
  if (hash && /^#[\w-]+$/.test(hash)) {
    const trigger = tabsEl.querySelector(`[data-bs-target="${hash}"]`)
    if (trigger) bootstrap.Tab.getOrCreateInstance(trigger).show()
  }

  tabsEl.addEventListener('shown.bs.tab', (e) => {
    const target = e.target.getAttribute('data-bs-target')
    if (target) history.replaceState(null, '', target)
  })
}

window['employees#show'] = function () {
  Timeago.init()
}

window['employees#form_datev'] = function () {
  Forms.initDatePickers($('.simple_form'))

  $('.taxable_pre_employment_fields').on('click', '.delete_taxable_pre_employment', function () {
    $(this).parents('.taxable_pre_employment_group').remove()
  })

  $('.add_taxable_pre_employment').on('click', function () {
    const template = $('.taxable_pre_employment_template').text()

    $(template).removeClass('hidden').appendTo('.taxable_pre_employment_fields')
    Forms.initDatePickers($('.simple_form'))
  })
}

window['employees#form_datev_update'] = function () {
  const hrefArray = window.location.href.split('/')
  if (hrefArray.slice(-1)[0] === 'form_datev_update') {
    window.history.replaceState(null, '', [...hrefArray.slice(0, -1), 'form_datev'].join('/'))
  }
}

window['employees#profile'] = function () {
  $(document).on('change', '#profile_template_id', function () {
    window.location = '?template_id=' + this.value
  })

  Profile.initEditable()
}
